import * as types from '../actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  ordersIds: {},
  recommendedProducts: {},
  easyConnection: {},
  agentAssistMacroRecommendation: {},
};

const mlData = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ML_ORDERS_IDS:
      return {
        ...state,
        ordersIds: {
          ...state.ordersIds,
          [action.ticketId]: action.ordersObject,
        },
      };
    case types.SET_RECOMMENDED_PRODUCTS_FOR_PARTNER:
      return dotProp.set(state, `recommendedProducts.${action.ticketId}`, action.data);
    case types.SET_EASY_CONNECTION_DATA:
      return dotProp.set(state, `easyConnection.${action.ticketId}`, action.data);
    case types.SET_RECOMMENDATION_AS_PREVIOUSLY_TRIGGERED:
      if (state.recommendedProducts[action.ticketId]) {
        return dotProp.set(state, `recommendedProducts.${action.ticketId}.previouslyTriggeredRecommendations`, true);
      }

      return state;
    case types.SET_AGENT_ASSIST_MACRO_RECOMMENDATION:
      return { ...state, agentAssistMacroRecommendation: action.data };
    default:
      return state;
  }
};

export default mlData;
